var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99998 12.125C3.11159 12.125 0.192218 6.99163 0.0708591 6.77323C0.0243879 6.68964 0 6.59557 0 6.49993C0 6.40429 0.0243879 6.31022 0.0708591 6.22662C0.192218 6.00838 3.11159 0.875 8.99998 0.875C14.8884 0.875 17.8078 6.00837 17.9291 6.22677C17.9756 6.31036 18 6.40443 18 6.50007C18 6.59572 17.9756 6.68978 17.9291 6.77338C17.8078 6.99162 14.8884 12.125 8.99998 12.125ZM1.22441 6.49916C1.8935 7.5132 4.52051 11 8.99998 11C13.4937 11 16.109 7.51602 16.7756 6.50084C16.1065 5.4868 13.4795 2 8.99998 2C4.50631 2 1.89097 5.48398 1.22441 6.49916ZM8.99998 9.875C7.13895 9.875 5.62498 8.36103 5.62498 6.5C5.62498 4.63897 7.13895 3.125 8.99998 3.125C10.861 3.125 12.375 4.63897 12.375 6.5C12.375 8.36103 10.861 9.875 8.99998 9.875ZM8.99998 4.25C7.75939 4.25 6.74998 5.25941 6.74998 6.5C6.74998 7.74059 7.75939 8.75 8.99998 8.75C10.2406 8.75 11.25 7.74059 11.25 6.5C11.25 5.25941 10.2406 4.25 8.99998 4.25Z",
    fill: "#FAB317"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyes);
export default __webpack_public_path__ + "static/media/icon-eyes.72ed2774840a472eb41413f2818324a6.svg";
export { ForwardRef as ReactComponent };